export default __webpack_public_path__ + "locales/pt-BR/PeopleTranslations.json?hash=e234490a7ff9e1428c592f43ae456bad";